import * as Sentry from '@sentry/nextjs';
import { ZodTypeAny } from 'zod';

type RateWithPackage = { id?: unknown; package?: unknown };

export const hasBrokenPackage = (
  rate: RateWithPackage | null | undefined,
  packageSchema: ZodTypeAny
): boolean => !!rate && rate.package != null && !packageSchema.safeParse(rate.package).success;

export const dropBrokenPackage = <T extends RateWithPackage | null | undefined>(
  rate: T,
  packageSchema: ZodTypeAny,
  unavailable: Record<string, unknown>
): T => {
  if (!rate || !hasBrokenPackage(rate, packageSchema)) {
    return rate;
  }
  Sentry.captureMessage(`Rate ${String(rate.id)} has a package that fails the schema`, {
    level: 'warning',
  });
  return { ...rate, ...unavailable, package: null } as T;
};
